(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.BrandStudioCurrency = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  const codes = ['SEK', 'THB', 'USD', 'EUR'];
  function currency(value) { return codes.includes(value) ? value : 'SEK'; }
  function positive(value) { const n = Number(value); return Number.isFinite(n) && n > 0 ? n : null; }
  function validRates(value) { return value && codes.every(code => positive(value[code])) && Number(value.SEK) === 1; }
  function format(amountSEK, code, rates, language) {
    code = currency(code);
    const amount = Number(amountSEK);
    if (!Number.isFinite(amount) || !validRates(rates)) throw new Error('Invalid quote amount or exchange rates');
    const locale = {sv: 'sv-SE', en: 'en-US', th: 'th-TH'}[String(language).slice(0, 2)] || 'en-US';
    return (code === 'SEK' ? '' : '≈ ') + new Intl.NumberFormat(locale, {
      style: 'currency', currency: code, currencyDisplay: 'code',
      minimumFractionDigits: code === 'SEK' ? 0 : 2,
      maximumFractionDigits: code === 'SEK' ? 0 : 2
    }).format(amount * Number(rates[code]));
  }
  function liveRate(payload, quote) {
    const n = positive(payload && payload.rate);
    if (!n || String(payload.base).toUpperCase() !== 'SEK' || String(payload.quote).toUpperCase() !== quote || !/^\d{4}-\d{2}-\d{2}$/.test(payload.date || '')) throw new Error('Invalid exchange-rate response');
    return {rate: n, date: payload.date};
  }
  return {codes, currency, positive, validRates, format, liveRate};
});
